import React, { Component } from "react";
import styled from "styled-components";
import "./About.css";

/* =========================================================
   PAGE
========================================================= */

const Page = styled.section`
  direction: rtl;
  position: relative;
  overflow: hidden;

  padding: 110px 20px 130px;

  background:
    radial-gradient(
      circle at 90% 5%,
      rgba(37, 99, 235, 0.22),
      transparent 30%
    ),
    radial-gradient(
      circle at 5% 70%,
      rgba(124, 58, 237, 0.16),
      transparent 30%
    ),
    linear-gradient(
      145deg,
      #050b16 0%,
      #081525 48%,
      #0b1d35 100%
    );

  &::before {
    content: "";
    position: absolute;
    inset: 0;

    background-image:
      linear-gradient(
        rgba(255,255,255,0.025) 1px,
        transparent 1px
      ),
      linear-gradient(
        90deg,
        rgba(255,255,255,0.025) 1px,
        transparent 1px
      );

    background-size: 55px 55px;

    pointer-events: none;
  }
`;

/* =========================================================
   HEADER
========================================================= */

const Header = styled.div`
  position: relative;
  z-index: 2;

  max-width: 900px;

  margin: 0 auto 75px;

  text-align: center;

  h1 {
    margin: 0 0 20px;

    color: #fff;

    font-size: clamp(43px, 5vw, 66px);

    line-height: 1.05;

    font-weight: 900;

    letter-spacing: -2px;
  }

  h1 span {
    background:
      linear-gradient(
        90deg,
        #60a5fa,
        #818cf8,
        #c084fc
      );

    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  p {
    max-width: 700px;

    margin: auto;

    color: #aebdd0;

    font-size: 19px;

    line-height: 1.8;
  }

  @media (max-width: 600px) {
    margin-bottom: 55px;

    h1 {
      font-size: 42px;
      letter-spacing: -1px;
    }

    p {
      font-size: 16px;
    }
  }
`;

/* =========================================================
   INTRO
========================================================= */

const AboutText = styled.div`
  position: relative;
  z-index: 2;

  max-width: 1050px;

  margin: 0 auto 75px;

  text-align: center;

  color: white;

  h2 {
    margin: 0 0 20px;

    color: #fff;

    font-size: clamp(31px, 4vw, 45px);

    line-height: 1.2;

    font-weight: 900;

    letter-spacing: -1px;
  }

  h2 span {
    background:
      linear-gradient(
        90deg,
        #60a5fa,
        #818cf8,
        #c084fc
      );

    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .intro {
    max-width: 900px;

    margin: 0 auto;

    color: #cbd5e1;

    font-size: 19px;

    line-height: 2;
  }

  @media (max-width: 600px) {
    h2 {
      font-size: 31px;
    }

    .intro {
      font-size: 16px;
      line-height: 1.85;
    }
  }
`;

/* =========================================================
   FEATURES
========================================================= */

const Features = styled.div`
  position: relative;
  z-index: 2;

  max-width: 1200px;

  margin: 0 auto 90px;

  display: grid;

  grid-template-columns:
    repeat(auto-fit, minmax(240px, 1fr));

  gap: 22px;

  .feature {
    position: relative;

    min-height: 230px;

    padding: 32px 25px;

    text-align: center;

    border-radius: 24px;

    background:
      linear-gradient(
        145deg,
        rgba(255,255,255,0.095),
        rgba(255,255,255,0.035)
      );

    border: 1px solid rgba(255,255,255,0.10);

    box-shadow:
      0 18px 50px rgba(0,0,0,0.22);

    backdrop-filter: blur(18px);

    transition:
      transform 0.4s ease,
      border-color 0.4s ease,
      box-shadow 0.4s ease;
  }

  .feature:hover {
    transform: translateY(-8px);

    border-color:
      rgba(96,165,250,0.32);

    box-shadow:
      0 25px 60px rgba(0,0,0,0.35),
      0 10px 35px rgba(37,99,235,0.12);
  }

  .icon {
    width: 65px;
    height: 65px;

    margin: 0 auto 20px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 18px;

    background:
      rgba(59,130,246,0.10);

    border:
      1px solid rgba(96,165,250,0.16);

    font-size: 31px;
  }

  h3 {
    margin: 0 0 12px;

    color: #fff;

    font-size: 21px;

    font-weight: 800;
  }

  p {
    margin: 0;

    color: #aebbd0;

    font-size: 15px;

    line-height: 1.7;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;

    .feature {
      min-height: auto;
      padding: 28px 22px;
    }
  }
`;

/* =========================================================
   MARKETING SECTION
========================================================= */

const MarketingSection = styled.div`
  position: relative;
  z-index: 2;

  max-width: 1150px;

  margin: 0 auto 80px;

  padding: 55px 50px;

  border-radius: 32px;

  background:
    linear-gradient(
      145deg,
      rgba(37,99,235,0.12),
      rgba(124,58,237,0.08),
      rgba(255,255,255,0.035)
    );

  border: 1px solid rgba(255,255,255,0.10);

  box-shadow:
    0 30px 80px rgba(0,0,0,0.30);

  h2 {
    margin: 0 0 25px;

    color: white;

    font-size: 38px;

    font-weight: 900;

    text-align: center;
  }

  h2 span {
    background:
      linear-gradient(
        90deg,
        #60a5fa,
        #c084fc
      );

    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    margin: 0 0 18px;

    color: #cbd5e1;

    font-size: 18px;

    line-height: 2;

    text-align: center;
  }

  p:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 700px) {
    padding: 35px 22px;

    border-radius: 24px;

    h2 {
      font-size: 29px;
    }

    p {
      font-size: 16px;
      line-height: 1.85;
    }
  }
`;

/* =========================================================
   PROCESS
========================================================= */

const ProcessSection = styled.div`
  position: relative;
  z-index: 2;

  max-width: 1150px;

  margin: 0 auto 90px;

  text-align: center;

  h2 {
    margin-bottom: 45px;

    color: white;

    font-size: 40px;

    font-weight: 900;
  }

  h2 span {
    background:
      linear-gradient(
        90deg,
        #60a5fa,
        #c084fc
      );

    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .steps {
    display: grid;

    grid-template-columns:
      repeat(auto-fit, minmax(220px, 1fr));

    gap: 20px;
  }

  .step {
    padding: 28px 22px;

    border-radius: 22px;

    background: rgba(255,255,255,0.045);

    border:
      1px solid rgba(255,255,255,0.08);
  }

  .number {
    width: 48px;
    height: 48px;

    margin: 0 auto 17px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 14px;

    color: white;

    background:
      linear-gradient(
        135deg,
        #2563eb,
        #6366f1
      );

    font-weight: 900;
  }

  h3 {
    margin-bottom: 10px;

    color: white;

    font-size: 19px;
  }

  p {
    margin: 0;

    color: #aebbd0;

    font-size: 14px;

    line-height: 1.7;
  }

  @media (max-width: 600px) {
    h2 {
      font-size: 31px;
    }
  }
`;

/* =========================================================
   CTA
========================================================= */

const CTA = styled.div`
  position: relative;
  z-index: 2;

  max-width: 900px;

  margin: 0 auto;

  padding: 50px 30px;

  text-align: center;

  border-radius: 30px;

  background:
    linear-gradient(
      135deg,
      rgba(37,99,235,0.16),
      rgba(124,58,237,0.13)
    );

  border:
    1px solid rgba(96,165,250,0.16);

  h2 {
    margin: 0 0 15px;

    color: white;

    font-size: 36px;

    font-weight: 900;
  }

  p {
    max-width: 700px;

    margin: 0 auto;

    color: #cbd5e1;

    font-size: 17px;

    line-height: 1.8;
  }

  @media (max-width: 600px) {
    padding: 38px 20px;

    h2 {
      font-size: 29px;
    }

    p {
      font-size: 15px;
    }
  }
`;

/* =========================================================
   COMPONENT
========================================================= */

class About extends Component {

  render() {

    return (

      <Page>

        {/* HEADER */}

        <Header>

          <h1>
            מי <span>אנחנו</span>
          </h1>

          <p>
            אנחנו בונים אתרים שנועדו לא רק להיראות טוב —
            אלא לעזור לעסק לבלוט, להיחשף ולהגיע ללקוחות חדשים.
          </p>

        </Header>


        {/* INTRO */}

        <AboutText>

          <h2>
            SITE <span>B2B</span>
          </h2>

          <h2>
            בונים אתרים שמביאים <span>תוצאות</span>
          </h2>

          <p className="intro">
            בעולם הדיגיטלי של היום, האתר של העסק הוא הרבה יותר
            מכרטיס ביקור. הוא המקום שבו לקוח פוטנציאלי פוגש
            את העסק בפעם הראשונה, מקבל רושם ראשוני ומחליט
            האם ליצור קשר.
          </p>

          <br />

          <p className="intro">
            ב־SITE B2B אנחנו מתמחים בבניית אתרי אינטרנט
            מקצועיים, מהירים ומודרניים, עם שילוב בין עיצוב,
            טכנולוגיה, חוויית משתמש וחשיבה שיווקית.
          </p>

          <br />

          <p className="intro">
            המטרה שלנו היא ליצור אתר שמציג את העסק בצורה
            מקצועית, מסביר ללקוח בצורה ברורה מה אתם מציעים
            ומוביל אותו בצורה טבעית לפעולה — יצירת קשר,
            שיחת טלפון, WhatsApp או השארת פרטים.
          </p>

        </AboutText>


        {/* FEATURES */}

        <Features>

          <div className="feature">

            <div className="icon">
              🚀
            </div>

            <h3>
              אתר שמביא לקוחות
            </h3>

            <p>
              האתר בנוי מתוך חשיבה על הדרך שבה גולש הופך
              למתעניין וללקוח פוטנציאלי.
            </p>

          </div>


          <div className="feature">

            <div className="icon">
              🔍
            </div>

            <h3>
              קידום אורגני בגוגל
            </h3>

            <p>
              מבנה נכון, תוכן איכותי ותשתית טכנית המאפשרים
              לאתר להיות מוכן לעבודה עם SEO וקידום אורגני.
            </p>

          </div>


          <div className="feature">

            <div className="icon">
              📱
            </div>

            <h3>
              התאמה מלאה למובייל
            </h3>

            <p>
              האתר מותאם למחשב, טאבלט וסמארטפון כדי שהלקוחות
              יוכלו לגלוש ויצור קשר מכל מכשיר.
            </p>

          </div>


          <div className="feature">

            <div className="icon">
              ⚡
            </div>

            <h3>
              מהירות וביצועים
            </h3>

            <p>
              אנחנו שמים דגש על ביצועים, טעינה מהירה
              וחוויית משתמש חלקה ונוחה.
            </p>

          </div>


          <div className="feature">

            <div className="icon">
              🎯
            </div>

            <h3>
              התאמה לעסק שלך
            </h3>

            <p>
              האתר נבנה בהתאם לתחום הפעילות, לקהל היעד,
              לשירותים ולמטרות העסק.
            </p>

          </div>


          <div className="feature">

            <div className="icon">
              💬
            </div>

            <h3>
              יצירת קשר קלה
            </h3>

            <p>
              שילוב נקודות קשר ברורות כמו טלפון, WhatsApp
              וטפסים כדי להקל על הלקוח לפנות אליכם.
            </p>

          </div>

        </Features>


        {/* MARKETING */}

        <MarketingSection>

          <h2>
            אתר יפה זה טוב — אתר שמייצר <span>הזדמנויות</span> זה טוב יותר
          </h2>

          <p>
            אתר מקצועי צריך לעשות יותר מאשר להציג תמונות
            וטקסטים. הוא צריך להסביר ללקוח למה לבחור בעסק,
            לבנות אמון ולגרום לו להבין במהירות שאתם יכולים
            לתת לו את הפתרון שהוא מחפש.
          </p>

          <p>
            כאשר האתר בנוי בצורה נכונה, הוא יכול לעבוד עבורכם
            גם כאשר העסק סגור. לקוח שמחפש שירות בגוגל יכול
            להגיע לאתר, להכיר את העסק, לקרוא על השירותים,
            לראות עבודות קודמות ולקבל דרך פשוטה ליצור קשר.
          </p>

          <p>
            לכן אנחנו משלבים באתר חשיבה שיווקית לצד העיצוב:
            כותרות ברורות, תוכן ממוקד, הנעה לפעולה, מבנה נכון,
            חוויית משתמש והתאמה למנועי חיפוש.
          </p>

          <p>
            המטרה היא לבנות עבור העסק נכס דיגיטלי שיכול
            לתמוך בפעילות השיווקית שלו לאורך זמן ולחזק
            את הנוכחות שלו ברשת.
          </p>

        </MarketingSection>


        {/* SEO */}

        <MarketingSection>

          <h2>
            נוכחות בגוגל מתחילה ב־<span>בסיס נכון</span>
          </h2>

          <p>
            קידום אורגני בגוגל הוא תהליך שדורש זמן, תוכן,
            אופטימיזציה ועבודה מתמשכת. לכן כבר בשלב בניית
            האתר אנחנו שמים דגש על תשתית שמתאימה לעקרונות
            SEO.
          </p>

          <p>
            אנחנו מתייחסים למבנה האתר, היררכיית כותרות,
            תוכן, כתובות עמודים, התאמה למובייל, ביצועים,
            מטא־תגים ואלמנטים טכניים נוספים שיכולים לסייע
            למנועי החיפוש להבין טוב יותר את האתר והתוכן שלו.
          </p>

          <p>
            המטרה אינה רק להביא גולשים לאתר, אלא להביא
            גולשים רלוונטיים שמחפשים את השירות או המוצר
            שהעסק שלכם מציע.
          </p>

        </MarketingSection>


        {/* PROCESS */}

        <ProcessSection>

          <h2>
            איך אנחנו בונים את <span>האתר שלכם?</span>
          </h2>

          <div className="steps">

            <div className="step">

              <div className="number">
                01
              </div>

              <h3>
                היכרות עם העסק
              </h3>

              <p>
                מבינים את התחום, השירותים, קהל היעד
                והמטרות של העסק.
              </p>

            </div>


            <div className="step">

              <div className="number">
                02
              </div>

              <h3>
                תכנון האתר
              </h3>

              <p>
                בונים מבנה ברור ונוח שמאפשר ללקוח
                למצוא במהירות את מה שהוא מחפש.
              </p>

            </div>


            <div className="step">

              <div className="number">
                03
              </div>

              <h3>
                עיצוב ופיתוח
              </h3>

              <p>
                יוצרים עיצוב מקצועי ומפתחים אתר מהיר,
                רספונסיבי ומותאם למכשירים שונים.
              </p>

            </div>


            <div className="step">

              <div className="number">
                04
              </div>

              <h3>
                התאמה לקידום
              </h3>

              <p>
                מכינים את מבנה האתר והתוכן לעבודה
                נכונה עם מנועי חיפוש.
              </p>

            </div>


            <div className="step">

              <div className="number">
                05
              </div>

              <h3>
                השקה וליווי
              </h3>

              <p>
                מעלים את האתר לאוויר וממשיכים לשפר
                ולעדכן אותו בהתאם לצורכי העסק.
              </p>

            </div>

          </div>

        </ProcessSection>


        {/* CTA */}

        <CTA>

          <h2>
            העסק שלכם מוכן לנוכחות דיגיטלית חזקה?
          </h2>

          <p>
            אנחנו כאן כדי לבנות לכם אתר מקצועי, מודרני
            ומותאם לעסק — אתר שמציג אתכם בצורה נכונה,
            מאפשר ללקוחות למצוא אתכם ומקל עליהם ליצור קשר.
          </p>

        </CTA>

      </Page>

    );
  }
}

export default About;
